export default () => {
  const getYoutubeIdFromUrl = (url: string): string | null => {
    const validYoutubeId = /^[a-zA-Z0-9_-]{11}$/
    const getValidId = (value?: string | null) =>
      value && validYoutubeId.test(value) ? value : null
    const isYoutubeHost = (hostname: string) =>
      hostname === 'youtube.com' ||
      hostname.endsWith('.youtube.com') ||
      hostname === 'youtube-nocookie.com' ||
      hostname.endsWith('.youtube-nocookie.com')
    const normalizedUrl = url.trim()

    if (!normalizedUrl) {
      return null
    }

    try {
      const urlWithProtocol = /^[a-z][a-z\d+.-]*:\/\//i.test(normalizedUrl)
        ? normalizedUrl
        : `https://${normalizedUrl}`
      const parsedUrl = new URL(urlWithProtocol)
      const hostname = parsedUrl.hostname.toLowerCase().replace(/^www\./, '')

      if (hostname === 'youtu.be') {
        return getValidId(parsedUrl.pathname.split('/').filter(Boolean)[0])
      }

      if (isYoutubeHost(hostname)) {
        const queryVideoId = getValidId(parsedUrl.searchParams.get('v'))

        if (queryVideoId) {
          return queryVideoId
        }

        const pathParts = parsedUrl.pathname.split('/').filter(Boolean)
        const videoPathIndex = pathParts.findIndex(part =>
          ['embed', 'v', 'e', 'shorts', 'live'].includes(part),
        )

        return getValidId(pathParts[videoPathIndex + 1])
      }
    } catch (_error) {
      // Fall through to the legacy regex for non-standard pasted values.
    }

    const regExp = /^(?:https?:\/\/)?(?:www\.)?(?:youtube(?:-nocookie)?\.com\/(?:[^/]+\/.+\/|(?:v|e(?:mbed)?|shorts|live)\/|.*[?&]v=)|youtu\.be\/)([^"&?/\s]{11})/
    const match = normalizedUrl.match(regExp)
    return match ? match[1] : null
  }

  return {
    getYoutubeIdFromUrl,
  }
}
